import { gql } from "@apollo/client";

export const GET_NEWS_LIST_QUERY =gql `
query GetNewsList($filter: NewsFilterOptions, $sort: [SortOptions], $pageOptions: PageOptions) {
    getNewsListWithPagination(filter: $filter, sort: $sort, pageOptions: $pageOptions) {
        news {
            arcimedes_row_id
            title
            text
            source_name
            source_url
            date
            deleted
            }
        totalCount
  }
}`;

export const GET_NEWS_QUERY = gql`
  query GetNews($arcimedesRowId: ID!) {
    getNews(arcimedes_row_id: $arcimedesRowId) {
        arcimedes_row_id
        title
        text
        source_name
        source_url
        date
        deleted
  }
}
`;

export const CREATE_OR_UPDATE_NEWS = gql`
  mutation CreateOrUpdateNews($input: NewsInput) {
    createOrUpdateNews(input: $input) {
      success
      message
      news {
        arcimedes_row_id
        title
        text
        source_name
        source_url
        date
        deleted
      }
      error
    }
}`